import React from "react";
import { motion } from "framer-motion";
import { Users } from "lucide-react";

const team = [
  {
    name: "KRISHNA KUMAR CHOUDHARY",
    role: "Director",
    icon: Users,
    img: null,
    description:
      "Visionary leader and industry pioneer known for strategic thinking, innovation, and driving long-term growth. Recognized for exceptional leadership and transformative impact in the logistics sector.",
  },
  {
    name: "SHYAM SUNDAR CHOUDHARY",
    role: "Director",
    icon: Users,
    img: null,
    description:
      "Dynamic executive recognized for operational excellence, team-building prowess, and innovative process improvements. Specializes in scaling operations and fostering sustainable business growth.",
  },
];

const TeamPage = () => {
  return (
    <section className="bg-white py-20 px-6 lg:px-20">
      <div className="max-w-6xl mx-auto text-center">
        {/* Section Title */}
        <motion.h2
          className="text-4xl font-extrabold text-[#211f57] mb-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Meet Our <span className="text-[#d32c30]">Board Members</span>
        </motion.h2>

        {/* Team Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
          {team.map((member, i) => {
            const Icon = member.icon;
            return (
              <motion.div
                key={i}
                className="group relative bg-gradient-to-r from-[#fff44f] via-[#fff86f] to-[#fffcb0] p-8 pt-14 rounded-2xl shadow-md border border-gray-200 transition-all duration-300 ease-in-out"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -10 }}
                transition={{ delay: i * 0.15, duration: 0.6 }}
              >
                {/* Name & Role */}
                <h4 className="text-xl font-semibold text-[#211f57] mt-2">{member.name}</h4>
                <p className="text-sm text-gray-600 mb-4">{member.role}</p>

                {/* Description */}
                <p className="text-sm text-gray-700 italic">{member.description}</p>

                {/* Floating Icon Badge */}
                <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white border-2 border-[#fde047] p-2 rounded-full shadow">
                  <Icon className="text-[#d32c30]" size={22} strokeWidth={2} />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TeamPage;
